<template>
  <section>
    <!-- Package Summary Cards (Exact 4 Cards) -->
    <KpiCards class="mb-3" :items="kpiItems" :loading="!(packageSummaries && packageSummaries.length)" :skeleton="4" />

    <data-table
      :headers="headers"
      :items="packages"
      commit="SET_STORES"
      :viewItem="viewItem"
      :editItem="editItem"
      :deleteItem="deleteItem"
    >
      <div slot="activator" class="row justify-sm-space-between mb-4">
        <v-col cols="3">
          <v-card-title class="px-0 pt-0 ps-products-title">
            {{ $t("package") }}</v-card-title>
        </v-col>

        <v-col cols="2" class="text-end">
          <v-btn
            depressed
            color="primary"
            @click="newItem"
          >
            <v-icon left>fal fa-plus-circle</v-icon>
            {{ $t("add_new") }}
          </v-btn>
        </v-col>
      </div>
    </data-table>
    <app-custom-dialog
      v-model="dialog"
      :footer="false"
      :title="'details'"
      @submit="submitForm"
    >
      <div slot="activator">
        <v-row>
          <v-col cols="4">{{ $t("id") }}</v-col>
          <v-col cols="8">{{ form.id }}</v-col>
          <v-col cols="4">{{ $t("name") }}</v-col>
          <v-col cols="8"
            ><v-chip outlined :color="packageName(form.name).color" small>
              {{ packageName(form.name).text }}</v-chip
            ></v-col
          >
          <v-col cols="4">{{ $t("day") }}</v-col>
          <v-col cols="8">{{ form.day }}</v-col>
          <v-col cols="4">{{ $t("icon") }}</v-col>
          <v-col cols="8">{{ form.icon }}</v-col>
          <v-col cols="4">{{ $t("month_count") }}</v-col>
          <v-col cols="8">{{ form.month_count }}</v-col>
          <v-col cols="4">{{ $t("product_count") }}</v-col>
          <v-col cols="8">{{ form.product_count }}</v-col>
          <v-col cols="4">{{ $t("bill_count") }}</v-col>
          <v-col cols="8">{{ form.bill_count }}</v-col>
          <v-col cols="4">{{ $t("user_count") }}</v-col>
          <v-col cols="8">{{ form.user_count }}</v-col>
          <v-col cols="4">{{ $t("branch_count") }}</v-col>
          <v-col cols="8">{{ form.branch_count }}</v-col>
          <v-col cols="4">{{ $t("price") }}</v-col>
          <v-col cols="8">{{ form.price }}</v-col>
          <v-col cols="4">{{ $t("date") }}</v-col>
          <v-col cols="8">{{ form.created_at | moment }}</v-col>
        </v-row>
      </div>
    </app-custom-dialog>
    <app-custom-dialog
      v-model="dialogAdd"
      :footer="true"
      :title="titleStatus"
      @submit="submitForm"
    >
      <div slot="activator">
        <TTextField
          label="name"
          v-model="form.name"
          :errorMessages="nameErrors"
          @input="$v.form.name.$touch()"
          @blur="$v.form.name.$touch()"
        />
        <TTextField
          label="day"
          v-model="form.day"
          :errorMessages="dayErrors"
          @input="$v.form.day.$touch()"
          @blur="$v.form.day.$touch()"
        />
        <TTextField
          label="icon"
          v-model="form.icon"
          :errorMessages="iconErrors"
          @input="$v.form.icon.$touch()"
          @blur="$v.form.icon.$touch()"
        />
        <TTextField
          label="month_count"
          v-model.number="form.month_count"
          :errorMessages="month_countErrors"
          @input="$v.form.month_count.$touch()"
          @blur="$v.form.month_count.$touch()"
        />
        <TTextField
          label="product_count"
          v-model.number="form.product_count"
          :errorMessages="product_countErrors"
          @input="$v.form.product_count.$touch()"
          @blur="$v.form.product_count.$touch()"
        />
        <TTextField
          label="bill_count"
          v-model.number="form.bill_count"
          :errorMessages="bill_countErrors"
          @input="$v.form.bill_count.$touch()"
          @blur="$v.form.bill_count.$touch()"
        />
        <TTextField
          label="user_count"
          v-model.number="form.user_count"
          :errorMessages="user_countErrors"
          @input="$v.form.user_count.$touch()"
          @blur="$v.form.user_count.$touch()"
        />
        <TTextField
          label="branch_count"
          v-model.number="form.branch_count"
          :errorMessages="branch_countErrors"
          @input="$v.form.branch_count.$touch()"
          @blur="$v.form.branch_count.$touch()"
        />
        <TTextField
          label="price"
          v-model="form.price"
          :errorMessages="priceErrors"
          @input="$v.form.price.$touch()"
          @blur="$v.form.price.$touch()"
        />
      </div>
    </app-custom-dialog>
  </section>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import { packageHead } from "@/utils/head";
import TTextField from "@/components/global/TextField";
import AppDetail from "@/components/products/details";
import { myMixin } from "@/mixin/main";
import { success, confirm } from "@/controllers/alert";
import { PACKAGE } from "@/validations/admin";

export default {
  mixins: [PACKAGE, myMixin],
  data: () => ({
    update: false,
    dialogAdd: false,
    dialog: false,
    form: {},
    packageSummaries: [],
  }),
  async created() {
    await Promise.all([this.fetchItem(), this.fetchSummary()]);
  },
  components: {
    DataTable,

    TTextField,
    AppDetail,
  },
  computed: {
    kpiItems() {
      return (this.packageSummaries || []).map((item, index) => ({
        key: index,
        label: this.packageName(item.name).text || this.$t(item.title),
        icon: item.icon || "fal fa-box",
        value: item.stores_count !== undefined ? item.stores_count : item.total || 0,
        note: this.$t("stores") || "Stores",
      }));
    },
    ...mapGetters({
      packages: "index/packages",
    }),
    headers() {
      return packageHead(this);
    },

    titleStatus() {
      return this.update ? "update" : "new";
    },
  },

  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async fetchSummary() {
      try {
        const { data } = await this.$http.get("package_summary");
        if (data && data.status && Array.isArray(data.data)) {
          this.packageSummaries = data.data.slice(0, 4);
        }
      } catch (error) {
        console.error("Failed to fetch package summary:", error);
      }
    },
    async fetchItem() {
      const body = {
        that: this,
        url: "packages_page",
        commit: "SET_PACKAGE",
      };
      await this.fetch(body);
    },

    async newItem() {
      await Help.clearForm(this.form, this);
      await this.fetchItem();
      this.update = false;
      this.dialogAdd = !this.dialogAdd;
    },
    async editItem({ id }) {
      const { data } = await this.$http.get(`packages/${id}`);
      this.form = data.data;
      this.update = true;
      this.dialogAdd = !this.dialogAdd;
    },
    async deleteItem({ id }) {
      try {
        const { isConfirmed } = await confirm({
          props: this,
          text: "want_to_delete",
        });
        if (isConfirmed) {
          const { data } = await this.$http.delete(`packages/${id}`);
          if (data.status) {
            await Help.clearForm(this.form, this);
            await Promise.all([this.fetchItem(), this.fetchSummary()]);
            await success(this, data.message);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    viewItem(item) {
      this.form = item;
      this.dialog = !this.dialog;
    },
    async submitForm() {
      var result;
      try {
        this.$v.form.$touch();
        if (!this.$v.form.$invalid) {
          if (this.update) {
            result = await this.$http.put(
              `packages/${this.form.id}`,
              this.form
            );
          } else {
            result = await this.$http.post("packages", this.form);
          }
          if (result.data.status) {
            this.dialogAdd = !this.dialogAdd;
            await Help.clearForm(this.form, this);
            await Promise.all([this.fetchItem(), this.fetchSummary()]);
            await success(this, result.data.message);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
